module.exports = "/fonts/vendor/lightcase/src/lightcase.ttf?3b06e8ee1ad83746aad064beaf6dc56a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightcase/src/fonts/lightcase.ttf?55356177
// module id = 302
// module chunks = 1 2